//import { CheckCircleIcon, CheckIcon } from "@heroicons/react/24/outline";
import { IconCheck, IconCircleCheckFilled } from "@tabler/icons-react";
import ClientUtils from "../../utils/ClientUtils";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
  variant?: "default" | "circle";
}

const CheckmarkIcon = (props: Props) => {
  const { className, ...rest } = props;

  if (props.variant === "circle") {
    return (
      <IconCircleCheckFilled
        {...rest}
        className={ClientUtils.twClassNames("", props.className)}
      />
    );
  }

  return (
    <IconCheck
      {...rest}
      className={ClientUtils.twClassNames("", props.className)}
    />
  );
};
export default withIconSize(CheckmarkIcon);
